import { render, staticRenderFns } from "./ProjectProgress.vue?vue&type=template&id=5b6b38e6&"
import script from "./ProjectProgress.vue?vue&type=script&lang=js&"
export * from "./ProjectProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports